"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconUnpin = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconUnpin = function SvgIconUnpin(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 6.75h7.5V6A.75.75 0 009 5.25h-.375L8.299.697A.75.75 0 007.55 0H4.447A.75.75 0 003.7.697L3.375 5.25H3a.75.75 0 00-.75.75v.75zm5.208 1.343L6 9.551 4.543 8.093a.318.318 0 10-.45.45L5.552 10l-1.458 1.457a.318.318 0 10.45.45L6 10.449l1.458 1.458a.318.318 0 10.449-.45L6.45 10l1.457-1.457a.318.318 0 00-.45-.45z",
    fill: "currentColor"
  }));
};

exports.SvgIconUnpin = SvgIconUnpin;